export interface BranchData {
  id: string;
  name: string;

  phone: string;
  email: string;
  city: string;
  address: string;
}

export interface RepresentativeData {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  phone: string;
  email: string;
  photoFile?: File | null;
  existingContactId?: number;
}

export type LogoMode = "initials" | "url" | "upload";

export interface CompanyFormData {
  // Step 1 — Identity
  name: string;
  industry: string;
  phone: string;
  primaryEmail: string;
  website: string;
  address: string;
  city: string;
  // Step 2 — Branches
  branches: BranchData[];

  // Step 3 — Representatives
  representatives: RepresentativeData[];

  // Step 4 — Branding
  logoMode: LogoMode;
  logoUrl: string;
  logoFile: File | null;
  linkedin: string;
  facebook: string;
  instagram: string;
  x: string;
  websiteBranding: string;
  youtube: string;
  tags: string[];
}

export const INITIAL_FORM_DATA: CompanyFormData = {
  name: "",
  industry: "",
  phone: "",
  primaryEmail: "",
  website: "",
  address: "",
  city: "",
  branches: [],
  representatives: [],
  logoMode: "initials",
  logoUrl: "",
  logoFile: null,
  linkedin: "",
  youtube: "",
  facebook: "",
  instagram: "",
  x: "",
  websiteBranding: "",
  tags: [],
};

export const COMPANY_STEPS = [
  "Identity",
  "Branches",
  "Representatives",
  "Branding",
];
